import script from "./exchange.vue?vue&type=script&setup=true&lang=js"
export * from "./exchange.vue?vue&type=script&setup=true&lang=js"

import "./exchange.vue?vue&type=style&index=0&id=09f4ff16&lang=less"
import "./exchange.vue?vue&type=style&index=1&id=09f4ff16&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/pay.7pa.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09f4ff16"]])

export default __exports__